import FARES from '../../constants/fare-types';
export function getFareFamilyForAnalytics(fareFamily) {
  return FARES.FARE_FAMILIES_NAMES[fareFamily];
}
